var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 96,
    viewBox: "0 0 87 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9FC",
    d: "M19.2.86l45.817 9.775 5.997 9.867-12.466 58.87c-.458 2.161-2.58 3.542-4.742 3.085l-.006-.001L4.152 71.863c-2.158-.461-3.536-2.582-3.079-4.741l13.379-63.18c.458-2.16 2.58-3.541 4.742-3.084L19.2.86z",
    transform: "scale(-1 1) rotate(9 -41.619 -463.248)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEE3EC",
    d: "M20.29 10.894l34.8 7.425c.539.115.883.645.77 1.185l-.721 3.402c-.115.54-.646.886-1.186.771h-.001l-34.8-7.425c-.54-.115-.884-.645-.77-1.185l.721-3.402c.114-.54.645-.886 1.185-.771h.002zM17.595 23.621l42.819 9.136c.54.115.884.646.77 1.185l-.012.053c-.114.54-.645.886-1.185.772h-.002L17.166 25.63c-.54-.115-.884-.645-.77-1.185l.012-.053c.114-.54.645-.885 1.185-.77h.002zM16.602 28.31l20.766 4.431c.54.115.883.645.77 1.185l-.012.053c-.114.54-.645.886-1.186.771h-.001l-20.766-4.43c-.54-.116-.884-.646-.77-1.186l.012-.053c.114-.54.645-.885 1.185-.77h.002zM15.609 33l20.766 4.43c.54.115.884.645.77 1.185l-.012.053c-.114.54-.645.886-1.185.771h-.002l-20.766-4.43c-.54-.116-.883-.646-.77-1.186l.012-.053c.114-.54.645-.885 1.186-.77h.001z",
    transform: "scale(-1 1) rotate(9 -41.619 -463.248)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEEF5",
    d: "M63.095 11.265L63.102 19.662 71.985 19.669z",
    transform: "scale(-1 1) rotate(9 -41.619 -463.248) rotate(12 67.54 15.467)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.fa242131.svg";
export { ForwardRef as ReactComponent };